import {
  creatorProductList,
  creatorProductCreate,
  creatorProductUpdate,
  creatorProductDestroy,
} from '@/services/shop/creatorProducts.service'

export default {
  namespaced: true,
  state: {
    products: { data: [], meta: { pagination: { total: 0 } } },
    status: 'init',
  },
  getters: {
    getProducts: s => s.products,
    getStatus: s => s.status,
  },
  mutations: {
    SET_PRODUCTS(state, value) { state.products = value },
    SET_STATUS(state, value) { state.status = value },
  },
  actions: {
    async fetchProducts({ commit }, params) {
      commit('SET_STATUS', 'pending')
      try {
        const { data } = await creatorProductList(params)
        commit('SET_PRODUCTS', data)
      } catch (e) {
        this._vm.$root.$notify({ message: e?.response?.data?.message || 'Error', type: 'danger' })
      } finally {
        commit('SET_STATUS', 'init')
      }
    },

    async saveProduct({ dispatch }, { form, page, perPage }) {
      const action = form.id ? creatorProductUpdate(form.id, form) : creatorProductCreate(form)
      await action
      dispatch('fetchProducts', { page, per_page: perPage })
    },

    async removeProduct({ dispatch }, { id, page, perPage }) {
      await creatorProductDestroy(id)
      dispatch('fetchProducts', { page, per_page: perPage })
    },
  },
}
